<template>
  <div>
    <div class="section-title">订单基本信息</div>
    <el-form :model="form" label-width="200px" class="form-block" size="small">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="购买名称">
            <el-input v-model="form.buyName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报名创建时间">
            <el-input v-model="form.createTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="活动订单编号">
            <el-input v-model="form.activityOrderNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联商品订单编号">
            <el-input v-model="form.relationGoodsOrderNo" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="用户姓名">
            <el-input v-model="form.userName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户手机号">
            <el-input v-model="form.userMobile" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否已安装" v-if="0">
            <el-select v-model="form.activityOrderInstallStatus" placeholder="请选择" style="width: 100%"
              @change="validateInstallStatus">
              <el-option label="未勘察未安装" value="INVESTIGATION_INSTALL_INIT" />
              <el-option label="已勘察已安装" value="INVESTIGATION_INSTALL_COMPLETED" />
              <el-option label="已勘察不安装" value="INVESTIGATION_FINISHED_NOT_INSTALL" />
              <el-option label="未勘察不安装" value="INVESTIGATION_INIT_NOT_INSTALL" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否已安装" >
            <el-radio-group v-model="form.pileInstallOrderNo">
              <el-radio label="N" :disabled="form.orderStatus == 'BUYOUT_IN_USE_STATUS' || form.orderStatus == 'IN_USE'">否</el-radio>
              <el-radio label="Y" :disabled="form.orderStatus == 'BUYOUT_IN_USE_STATUS' || form.orderStatus == 'IN_USE'">是</el-radio>
            </el-radio-group>
          </el-form-item>
          
        </el-col>
        <el-col :span="12" v-if="0">
          <el-form-item label="客服联系状态" >
            <el-select v-model="form.activityOrderContractStatus" placeholder="请选择" style="width: 100%">
              <el-option label="待联系" value="WAIT_CONTRACT" />
              <el-option label="已联系" value="CONTRACTED" />
              <el-option label="未联系上" value="NOT_CONTRACT" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="0">
          <el-form-item label="不签约/不安装原因">
            <el-input v-model="form.installFailReason" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="0">
          <el-form-item label="关联主服订单编号">
            <el-input v-model="form.pileInstallOrderNo" @blur="validateInstallTime" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="0">
          <el-form-item label="充电桩安装完成时间">
            <el-date-picker v-model="form.pileInstallCompletedTime" type="datetime" placeholder="请选择"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" clearable @change="validateInstallTime" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订单状态">
            <el-input :value="getOrderStatusText()" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员服务状态">
            <el-input v-model="form.actualAmountStatusName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员服务累计使用时长（月）">
            <el-input v-model="form.actualAmountCumulativeMonths" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员服务累计支付（元）">
            <el-input v-model="form.actualAmountTotal" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备绑定时间">
            <el-input v-model="form.deviceBindTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="充电桩设备编号">
            <el-input v-model="form.pileCode" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="充电桩设备资产编号">
            <el-input v-model="form.pileAssetCode" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="解约类型">
            <el-input v-model="form.refundReasonTypeName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户解约申请时间">
            <el-input v-model="form.cancelRequestTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="解约完成时间">
            <el-input v-model="form.terminateCompleteTime" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户解约原因">
            <el-input v-model="form.refundCancelReason" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="买断类型">
            <el-input v-model="form.buyoutReasonTypeName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="买断完成时间">
            <el-input v-model="form.buyOutCancelFinishTime" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否违规买断">
            <el-input :value="getViolationBuyoutText()" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="违规买断原因">
            <el-input v-model="form.refundCancelReason" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="买断免押扣款金额（元）">
            <el-input v-model="form.buyoutFreeDepositAmount" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="芝麻信用状态">
            <el-input v-model="form.zmxyzt" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="所属代理商">
            <el-input v-model="form.agentName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代理商账号">
            <el-input v-model="form.agentPhone" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代理商级别">
            <el-input :value="getAgentLevelText(form.agentLevel)" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="上级代理">
            <el-input v-model="form.parentAgentName" disabled />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="省市区">
            <ZD-area-select ref="areaSelect" :key="areaSelectKey" :showLevel="'3'" :selProvince="form.province"
              :selCity="form.city" :selArea="form.area" :disabledFlag="false" @updateSelAreas="updateAreaSelection" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址">
            <el-input v-model="form.detailAddress" placeholder="请输入详细地址" />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" :rows="3" maxlength="500" show-word-limit
              placeholder="请输入备注，500字以内" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import ZDAreaSelect from "@/components/area-select/index.vue";

export default {
  name: "OrderInfo",
  components: {
    ZDAreaSelect,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    areaSelectKey: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    updateAreaSelection(areaData) {
      this.$emit("updateArea", areaData);
    },
    validateInstallTime() {
      if (this.form.pileInstallCompletedTime && !this.form.pileInstallOrderNo) {
        this.$message.warning('填写充电桩安装完成时间时，必须先填写关联主服订单编号');
        this.form.pileInstallCompletedTime = '';
        return false;
      }
      return true;
    },
    validateInstallStatus() {
      if (this.form.activityOrderInstallStatus === 'INVESTIGATION_INSTALL_COMPLETED' && !this.form.pileInstallCompletedTime) {
        this.$message.warning('选择安装状态为已勘察已安装时，必须填写安装完成时间');
        this.form.activityOrderInstallStatus = '';
        return false;
      }
      return true;
    },
    // 提交时的完整验证
    validateBeforeSubmit() {
      // 验证1：填写了安装完成时间，必须有关联主服订单编号
      if (this.form.pileInstallCompletedTime && !this.form.pileInstallOrderNo) {
        this.$message.error('填写充电桩安装完成时间时，必须先填写关联主服订单编号');
        return false;
      }

      // 验证2：选择了已勘察已安装，必须有安装完成时间
      if (this.form.activityOrderInstallStatus === 'INVESTIGATION_INSTALL_COMPLETED' && !this.form.pileInstallCompletedTime) {
        this.$message.error('选择安装状态为已勘察已安装时，必须填写安装完成时间');
        return false;
      }

      return true;
    },
    getOrderStatusText() {
      const statusMap = {
        'COMMIT': '已报名',
        'TO_SIGN': '待签约',
        'IN_SIGN': '已签约',
        'TO_INSTALL': '待安装',
        'TO_ACTIVATION': '待激活',
        'IN_USE': '使用中',
        'TO_COMPLIANCE': '待守约',
        'IN_OVERDUE': '已逾期',
        'IN_DEFAULTED': '已违约',
        'IN_CANCELING': '解约申请中',
        'IN_CANCELLED_BUYOUT': '已解约(买断)',
        'IN_CANCELLED_REFUNDED': '已解约(退出)',
        'IN_CANCELLED_DEFAULTED': '已解约(违约)',
        'IN_EXPIRED': '已解约(到期)',
        'IN_CLOSE': '已退出',
        'TO_RESET_SIGN': '待激活签约',
        'PAUSE': '暂停使用',
        'TO_RENEWED': '待续费',
        'BUYOUT_IN_USE_STATUS': '提前买断·使用中',
        "HAVING_ERROR_ILLEGAL_BUYOUT": "已解约·违约买断",
      };
      return statusMap[this.form.orderStatus] || this.form.orderStatus || '';
    },
    getViolationBuyoutText() {
      const value = this.form.isViolationBuyout !== undefined ? this.form.isViolationBuyout : this.form.isViolationBuyoutText;
      if (value === 1 || value === '1') {
        return '是';
      } else if (value === 0 || value === '0') {
        return '否';
      }
      return '';
    },
    getAgentLevelText(level) {
      const map = {
        LEVEL_ONE: "一级",
        LEVEL_TWO: "二级",
        LEVEL_THREE: "三级",
        "1": "一级",
        "2": "二级",
        "3": "三级",
        1: "一级",
        2: "二级",
        3: "三级",
      };
      return map[level] || map[String(level)] || level || "-";
    },
  },
};
</script>

<style lang="less" scoped>
.order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.order-no {
  color: #409EFF;
  font-weight: 500;
}

.form-block {
  background: #fff;
}
</style>
